import i18n from "@/langs/i18n"

export default class LangService {
  private static instance?: LangService;
  private supportedLangs: ['ru', 'en'] = ['ru', 'en'];

  private constructor() {
  }

  static getInstance() {
      if (typeof LangService.instance === 'undefined') {
        LangService.instance = new LangService();
      }
      return LangService.instance;
  }

  public set(locale: string) {
    i18n.global.locale.value = locale;
    localStorage.setItem("lang", locale);
  }

  public getLocalStorageLang(): string | null {
    return localStorage.getItem("lang")
  }

  public detectAndSetLanguage() {
    if (this.getLocalStorageLang() === null) {
      const browserLang = this.getInitialLanguageByBrowser();
      this.set(browserLang);
    }
  }

  public getInitialLanguageByBrowser() {
    const browserLang = navigator.language || navigator?.userLanguage;
    const baseLang = browserLang.slice(0, 2);

    return this.supportedLangs.includes(baseLang) ? baseLang : 'en';
  }

  public get() {
    return i18n.global.locale.value;
  }
}
